import React from 'react';

export default function InnovationTrial() {
  return (
     <div className="flex flex-col h-full items-center w-full">
      <h1 className="relative inline-block text-white text-center font-extrabold 
  max-w-4xl text-2xl lg:text-4xl font-nunito mb-4 
  bg-gradient-to-r from-[#92D050] to-[#8CC54F] 
  px-6 py-2
  before:content-[''] before:absolute before:left-0 before:top-1/2 
  before:-translate-y-1/2 before:-translate-x-full
  before:border-y-[16px] before:border-r-[16px] before:border-y-transparent 
  before:border-r-[#92D050]

  after:content-[''] after:absolute after:right-0 after:top-1/2 
  after:-translate-y-1/2 after:translate-x-full
  after:border-y-[16px] after:border-l-[16px] after:border-y-transparent 
  after:border-l-[#8CC54F]">Innovation & New Product Trial</h1>
     

      {/* Top Row - Two Boxes */}
      <div className="grid grid-cols-2 gap-2 mb-2">
        {/* Left Box - Innovation Awareness */}
        <div className="border-2 border-green-400 bg-[#f3fadc] rounded-xl p-2">
          <h2 className="text-center font-bold text-base mb-3">
            Innovation awareness is widespread (60%)
          </h2>
          <p className="text-sm leading-relaxed">
            Most dog owners report noticing an expansion of dog food options in the past year, 
            driven by new formulas, premium variants, specialty diets, and niche brands. 
            Younger owners (18-34), affluent followers, and multi-dog households are the 
            most informed.
          </p>
        </div>

        {/* Right Box - Over Half Tried New Product */}
        <div className="border-2 border-green-400 bg-[#f3fadc] rounded-xl p-2">
          <h2 className="text-center font-bold text-base mb-3">
            Over half of owners tried a new<br />dog food product (54%)
          </h2>
          <p className="text-sm mb-3">Among those who tried something new:</p>
          <ul className="text-sm space-y-1">
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>Multi-ingredient blends</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>Human-grade ingredients</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>Specialized households</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>Freeze-dried or dehydrated flavors</span>
            </li>
          </ul>
        </div>
      </div>

      {/* Middle Row - Two Boxes */}
      <div className="grid grid-cols-2 gap-2 mb-2">
        {/* Left Box - Trial Driven by Product Quality */}
        <div className="border-2 border-green-400 bg-[#f3fadc] rounded-xl p-2">
          <h2 className="text-center font-bold text-base mb-3">
            Trial is driven primarily by product quality cues
          </h2>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="text-sm mb-2">Among those who tried something new:</p>
              <ul className="text-sm space-y-1">
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span><span className="font-bold">53%</span> = Premium ingredients</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span><span className="font-bold">49%</span> = Nutritional/health benefits</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span><span className="font-bold">41%</span> = Original flavors</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span><span className="font-bold">39%</span> = Specialized diets</span>
                </li>
              </ul>
            </div>
            <div>
              <p className="text-sm leading-relaxed">
                This indicates a clear shift toward functional, 
                health-centric products, especially in premium tiers. 
                Price promotions also matter (42%), but 
                quality-focused reasons dominate.
              </p>
            </div>
          </div>
        </div>

        {/* Right Box - External Influence */}
        <div className="border-2 border-green-400 bg-[#f3fadc] rounded-xl p-2">
          <h2 className="text-center font-bold text-base mb-3">
            External influence plays a<br />secondary but meaningful role
          </h2>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="text-sm mb-2">Influencers are especially impactful for:</p>
              <ul className="text-sm space-y-1">
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>Younger buyers</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>Urban owners</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>Small dog owners (15lbs+)</span>
                </li>
              </ul>
            </div>
            <div>
              <ul className="text-sm space-y-1">
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>Vet recommendations: 18%</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span>
                  <span>Social media influencer endorsements: 10%</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Box - Satisfaction */}
      <div className="border-2 border-green-400 bg-[#f3fadc] rounded-xl p-3 mb-4">
        <h2 className="text-center font-bold text-base mb-3">
          Satisfaction with new products is<br />very high (54%: Top 2 box)
        </h2>
        <p className="text-sm text-center">
          Those who tried new products generally liked them:
        </p>
        <ul className="text-sm mt-2 flex justify-center space-x-8">
          <li className="flex items-start">
            <span className="mr-2">•</span>
            <span>Meal satisfaction = 3.8/7</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">•</span>
            <span>Health improvements noted (Top 2 box): 54% satisfaction</span>
          </li>
          <li className="flex items-start">
            <span className="mr-2">•</span>
            <span>Dissatisfaction is very uncommon (14%)</span>
          </li>
        </ul>
      </div>
    </div>
  );
}